import * as z from 'zod';
export const PipelineStepSchema = z.enum([
    'store_stats',
    'draw_winner',
    'unmask',
    'reorder',
    'guess_distribution',
    'unlock',
]);
export const PipelineStateSchema = z.object({
    status: z.enum(['idle', 'running', 'completed', 'failed']),
    currentStep: PipelineStepSchema.nullable(),
    lastStartedBy: z.string().nullable(),
    startedAt: z.int().nullable(),
    completedAt: z.int().nullable(),
    participantId: z.uuidv7().nullable(),
    unmaskedName: z.string().nullable(),
    error: z.string().nullable(),
});
export const UnmaskParticipantBodySchema = z.object({
    unmaskedName: z.string().min(1),
});
export const PipelineAuditRunSchema = z.object({
    participantId: z.string(),
    unmaskedName: z.string(),
    startedBy: z.string(),
    fromStep: PipelineStepSchema,
});
export const PipelineAuditEventSchema = z.looseObject({
    at: z.int(),
});
//# sourceMappingURL=pipeline.js.map